import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const WiFi = async (data) => {
  const response = await axios.post(
    webView ? `/wifi/ajax/new${banner}` : "/wifi/ajax/new",
    {
      ssid: data[2],
      encryption: data[1].toLowerCase(),
      password: data[1] !== "NONE" ? data[0]?.trim() : undefined,
      qrTitle: data[3],
      advertisingIabCategories: data[4],
      type: 17,
      token: token,
    }
  );
  return response.data;
};

export const WiFiEdit = async (data) => {
  const response = await axios.post(`/wifi/ajax/edit/${data[0]}`, {
    encryption: data[2].toLowerCase(),
    password: data[2] !== "NONE" ? data[1]?.trim() : undefined,
    ssid: data[3],
    qrTitle: data[4],
    advertisingIabCategories: data[5],
    type: 17,
    token: token,
  });
  return response.data;
};
